import { render } from "./RangeTabs.vue?vue&type=template&id=37d06c18&scoped=true"
import script from "./RangeTabs.vue?vue&type=script&lang=js"
export * from "./RangeTabs.vue?vue&type=script&lang=js"

import "./RangeTabs.vue?vue&type=style&index=0&id=37d06c18&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d06c18"]])

export default __exports__